export default __webpack_public_path__ + "static/media/Decision maker 1.6e4f7979.mp3";